import nodeClient from "./node-client";

export const addDoctorCommission = async (payload) => {
  const response = await nodeClient.post(
    `/service/private/v0/doctor/commission/add`,
    payload
  );
  return response?.data;
};


export const getDoctorCommissionList = async () => {
  const response = await nodeClient.get(
    `/service/private/v0/doctor/commission/list`
  );
  return response?.data;
};

export const getDoctorCommissionDetails = async (query) => {
  const response = await nodeClient.get(
    `/service/private/v0/doctor/commission/findOne?${query}`
  );
  return response?.data;
};